import script from "./Video.vue?vue&type=script&setup=true&lang=js"
export * from "./Video.vue?vue&type=script&setup=true&lang=js"

import "./Video.vue?vue&type=style&index=0&id=44d5b8e0&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44d5b8e0"]])

export default __exports__